export default "__VITE_ASSET__mbHR3Tzp__"